import React from 'react';
import clsx from 'clsx';

/*
 * What happens from the first visit, as one card.
 *
 * The front door and the sign-in page both carry it, so a person meets the
 * same four steps in the same words wherever they arrive. They follow the
 * setup every member walks: the company, then you and your apps, then ideas,
 * then the Workspace.
 */

const STEPS = [
  {
    title: 'Set up your company',
    desc: 'Your name, your work email and the company. A phone number too, if you want us to reach you.',
  },
  {
    title: 'Tell us about you and your apps',
    desc: 'Your role, the apps you use, and what AI may do in each. Skip anything you do not know.',
  },
  {
    title: 'See where AI can help',
    desc: 'Orbit suggests skills, plugins and builds that fit your work. Pick any, and connect only the apps they need.',
  },
  {
    title: 'Start in your Workspace',
    desc: 'Your idea or your problem arrives as your first message. Nothing is built without your approval.',
  },
];

export const OrbitSteps: React.FC<{ eyebrow?: string; className?: string }> = ({
  eyebrow = 'How it works',
  className = '',
}) => (
  <div className={clsx('rounded-[20px] border border-line bg-white px-7 py-7 shadow-[0_10px_40px_rgba(24,25,29,0.05)]', className)}>
    <div className="text-[11px] font-semibold uppercase tracking-[0.14em] text-eyebrow">{eyebrow}</div>
    <div className="mt-5">
      {STEPS.map((step, i) => (
        <div key={step.title} className="flex gap-4 border-t border-line-soft py-4 first:pt-0">
          <span
            className={clsx(
              'mt-0.5 grid h-7 w-7 shrink-0 place-items-center rounded-full font-sans text-[12px] font-bold',
              i === 0 && 'bg-accent-500 text-black',
              i > 0 && 'bg-canvas-inset text-ink-muted',
            )}
          >
            {i + 1}
          </span>
          <div className="min-w-0">
            <div className="text-[14px] font-bold text-ink">{step.title}</div>
            <p className="m-0 mt-1 text-[12.5px] leading-[19px] text-ink-dim">{step.desc}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default OrbitSteps;
